module.exports = __webpack_public_path__ + "img/jbxxbg1.4541c705.png";